<div *ngIf="isInitialized" class="info-header">
  <div class="container-fluid lh-container-fluid-sm">
    <div class="flex">
      <div class="heading-5">
        <a class="breadcrumb-link" [routerLink]="'/dashboard'">{{ shop.name }}</a>
        <span class="breadcrumb-divider">></span>
        <span>{{ 'PRICING' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isInitialized" class="container-fluid lh-container-fluid-sm main-container">
  <div>
    <p>{{ 'CUSTOM_PRICING_DESCRIPTION_1' | translate }}</p>
    <p>{{ 'CUSTOM_PRICING_DESCRIPTION_2' | translate }}</p>
  </div>

  <hr />

  <div class="form-group custom-pricing" [class.selected]="isCustomPricingEnabled">
    <div>{{ 'ENABLE_CUSTOM_PRICING' | translate }}</div>
    <div class="toggle">
      <input type="checkbox" id="toggleCustomPricing" [(ngModel)]="isCustomPricingEnabled" />
      <label for="toggleCustomPricing">Toggle</label>
    </div>
  </div>

  <!-- Form containing all pricing input elements -->
  <form #form="ngForm">
    <div class="form-group">
      <!-- Hourly Rate -->
      <div class="price-input">
        <span class="price-label">{{ 'HOURLY_RATE' | translate }} {{ 'PER_BAG' | translate | lowercase }}</span>
        <span class="currency-symbol">{{ currencySymbol }}</span>
        <input
          id="hourlyRate"
          name="hourlyRate"
          type="number"
          class="form-control text-end"
          [step]="0.01"
          [(ngModel)]="hourlyRate"
          (change)="onHourlyRateChange($event.target.value)"
          [disabled]="!isCustomPricingEnabled"
          [min]="0"
          [max]="100"
          required
        />
      </div>
    </div>

    <div class="form-group">
      <!-- Daily Rate -->
      <div class="price-input">
        <span class="price-label">{{ 'DAILY_RATE' | translate }} {{ 'PER_BAG' | translate | lowercase }}</span>
        <span class="currency-symbol">{{ currencySymbol }}</span>
        <input
          id="dailyRate"
          name="dailyRate"
          type="number"
          class="form-control text-end"
          [step]="0.01"
          [(ngModel)]="dailyRate"
          (change)="onDailyRateChange($event.target.value)"
          [disabled]="!isCustomPricingEnabled"
          [min]="0"
          [max]="200"
          required
        />
      </div>

      <div class="alert alert-danger mt-2" *ngIf="validationError">
        {{ validationError | translate }}
      </div>
    </div>
  </form>

  <hr />

  <button class="btn btn-primary btn-block" [disabled]="isSaveButtonDisabled" (click)="save()">
    {{ 'SAVE' | translate }}
  </button>

  <button class="btn btn-link btn-block" (click)="cancel()">
    {{ 'CANCEL' | translate }}
  </button>
</div>
